(() => {
  'use strict';
  const run = async () => {
    const container = document.querySelector('[data-lpon-auto-localization]');
    if (!container || window.Shopify?.designMode) return;
    const form = container.querySelector('form');
    const configNode = container.querySelector('[data-lpon-localization-config]');
    if (!form || !configNode) return;
    let config;
    try { config = JSON.parse(configNode.textContent); } catch { return; }
    const key = 'LPON-auto-market-v1';
    const storage = {
      get() { try { return sessionStorage.getItem(key); } catch { return null; } },
      set(value) { try { sessionStorage.setItem(key, value); return sessionStorage.getItem(key) === value; } catch { return false; } }
    };
    document.querySelectorAll('form[action*="/localization"]').forEach(other => {
      if (other !== form) other.addEventListener('submit', () => storage.set('manual'));
    });
    if (storage.get() || navigator.webdriver || /bot|crawler|spider|facebookexternalhit/i.test(navigator.userAgent)) return;
    if (!storage.set('checking')) return;
    const root = (typeof config.root === 'string' ? config.root : '/').replace(/\/?$/, '/');
    try {
      const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {
        credentials: 'same-origin', signal: AbortSignal.timeout(4000)
      });
      if (!response.ok) return;
      const suggestions = await response.json();
      const country = suggestions.detected_values?.country?.handle || suggestions.suggestions?.[0]?.parts?.country?.handle;
      if (typeof country !== 'string' || !config.countries.includes(country) || !config.countryLanguages[country]) return;
      const targetLocale = config.countryLanguages[country];
      const locale = config.locales.includes(targetLocale) ? targetLocale : config.locales.includes('en') ? 'en' : config.locale;
      storage.set(country + ':' + locale);
      if (country === config.country && locale === config.locale) return;
      form.elements.country_code.value = country;
      form.elements.language_code.value = locale;
      form.elements.return_to.value = location.pathname + location.search + location.hash;
      form.submit();
    } catch { /* Keep the current, working Shopify locale if detection is unavailable. */ }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, {once:true});
  else run();
})();

